import { post } from '../../base';

import { Product } from './types-product';
import { ProductPayloadCreate } from './types-product-create';

export function createMerchantProduct(payload: ProductPayloadCreate): Promise<Product> {
  const { body } = payload;
  return post('v5/merchant/products', { json: body }).json();
}
